<ng-container *ngIf="priceEngine.product">
    <app-product-structured-data
        [product]="priceEngine.product"
        [sku]="priceEngine.sku"
        [skuId]="priceEngine.currentSkuId"
        [unitPrice]="priceEngine.unitPrice"></app-product-structured-data>
    <div class="bg-grey">
        <div class="product">
            <div class="container px-0">
                <ng-container *ngIf="deviceType === 'mobile'">
                    <app-product-details-info
                        [product]="priceEngine.product"
                        [sku]="priceEngine.sku"
                        [skuId]="priceEngine.currentSkuId"></app-product-details-info>
                    <app-product-details-images
                        [product]="priceEngine.product"
                        [discount]="priceEngine.discount"
                        [deviceType]="deviceType"></app-product-details-images>
                    <app-product-details-selection
                        [product]="priceEngine.product"
                        [sku]="priceEngine.sku"
                        [qty]="priceEngine.qty"
                        [leadTime]="priceEngine.leadtime"
                        [unitPrice]="priceEngine.unitPrice"
                        [estDeliveryDate]="priceEngine.estDeliveryDate"
                        (newSkuSelection)="priceEngine.doRecalculation()"
                        (newQuantity)="priceEngine.updateQuantity($event)"
                        (newRisers)="priceEngine.doRecalculation()"></app-product-details-selection>
                    <app-product-details-order
                        *ngIf="!priceEngine.product.jobLot || (priceEngine.product.jobLot && priceEngine.sku.stockFree > 0 && priceEngine.sku.stockFree >= priceEngine.qty)"
                        [product]="priceEngine.product"
                        [sku]="priceEngine.sku"
                        [qty]="priceEngine.qty"
                        [stickyBehavior]="true"
                        (newOrder)="addToBasket($event)"></app-product-details-order>
                    <app-product-details-description [product]="priceEngine.product"></app-product-details-description>
                    <app-bespoke-banner [product]="priceEngine.product"></app-bespoke-banner>
                    <app-product-details-attributes [product]="priceEngine.product"></app-product-details-attributes>
                    <app-product-details-rating [product]="priceEngine.product"></app-product-details-rating>
                </ng-container>

                <ng-container *ngIf="deviceType === 'tabletV' || deviceType === 'tabletH'">
                    <div class="row g-0">
                        <div class="col-6 p-4">
                            <app-product-details-images
                                [product]="priceEngine.product"
                                [discount]="priceEngine.discount"
                                [deviceType]="deviceType"></app-product-details-images>
                        </div>
                        <div class="col-6">
                            <app-product-details-info
                                [product]="priceEngine.product"
                                [sku]="priceEngine.sku"
                                [skuId]="priceEngine.currentSkuId"></app-product-details-info>
                        </div>
                        <div class="col-12">
                            <app-product-details-selection
                                [product]="priceEngine.product"
                                [sku]="priceEngine.sku"
                                [qty]="priceEngine.qty"
                                [leadTime]="priceEngine.leadtime"
                                [leadtimeOverride]="priceEngine.leadtimeOverride"
                                [unitPrice]="priceEngine.unitPrice"
                                [estDeliveryDate]="priceEngine.estDeliveryDate"
                                (newSkuSelection)="priceEngine.doRecalculation()"
                                (newQuantity)="priceEngine.updateQuantity($event)"
                                (newRisers)="priceEngine.doRecalculation()"></app-product-details-selection>
                            <app-product-details-order
                                *ngIf="!priceEngine.product.jobLot || (priceEngine.product.jobLot && priceEngine.sku.stockFree > 0 && priceEngine.sku.stockFree >= priceEngine.qty)"
                                [product]="priceEngine.product"
                                [sku]="priceEngine.sku"
                                [stickyBehavior]="true"
                                (newOrder)="addToBasket($event)"></app-product-details-order>
                            <app-product-details-description
                                [product]="priceEngine.product"></app-product-details-description>
                            <app-product-details-attributes
                                [product]="priceEngine.product"></app-product-details-attributes>
                            <app-product-details-rating [product]="priceEngine.product"></app-product-details-rating>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="deviceType === 'desktop'">
                    <div class="row g-0">
                        <div class="col-6 bg-light">
                            <app-product-details-images
                                [product]="priceEngine.product"
                                [discount]="priceEngine.discount"
                                [deviceType]="deviceType"></app-product-details-images>
                            <app-product-details-attributes
                                [product]="priceEngine.product"></app-product-details-attributes>
                            <app-product-details-rating [product]="priceEngine.product"></app-product-details-rating>
                            <app-product-details-description
                                [product]="priceEngine.product"></app-product-details-description>
                        </div>
                        <div class="col-6">
                            <app-product-details-info
                                [product]="priceEngine.product"
                                [sku]="priceEngine.sku"
                                [skuId]="priceEngine.currentSkuId"></app-product-details-info>
                            <app-product-details-selection
                                [product]="priceEngine.product"
                                [sku]="priceEngine.sku"
                                [qty]="priceEngine.qty"
                                [unitPrice]="priceEngine.unitPrice"
                                [leadTime]="priceEngine.leadtime"
                                [leadtimeOverride]="priceEngine.leadtimeOverride"
                                [estDeliveryDate]="priceEngine.estDeliveryDate"
                                (newSkuSelection)="priceEngine.doRecalculation()"
                                (newQuantity)="priceEngine.updateQuantity($event)"
                                (newRisers)="priceEngine.doRecalculation()"></app-product-details-selection>
                        </div>
                    </div>
                </ng-container>
            </div>

            <ng-container *ngIf="deviceType === 'desktop'">
                <app-product-details-order
                *ngIf="!priceEngine.product.jobLot || (priceEngine.product.jobLot && priceEngine.sku.stockFree > 0 && priceEngine.sku.stockFree >= priceEngine.qty)"
                [product]="priceEngine.product"
                [sku]="priceEngine.sku"
                [stickyBehavior]="true"
                (newOrder)="addToBasket($event)"></app-product-details-order>

            </ng-container>

            <app-product-details-related-products
                *ngIf="priceEngine.linkedProducts.length"
                [linkedProducts]="priceEngine.linkedProducts"
                [deviceType]="deviceType"></app-product-details-related-products>

            <section
                *ngIf="priceEngine.linkedCaseStudies.length > 0"
                class="bg-slate-10">
                <div class="container py-4 py-xl-5">
                    <h2 class="fs-5 fw-bold text-center text-xl-start mb-4">Related Case Studies</h2>
                    <div class="row g-4">
                        <ng-container *ngFor="let cs of priceEngine.linkedCaseStudies; let last = last">
                            <div
                                class="col-12 col-sm-6 col-md-6 col-xl-4 text-center text-xl-start"
                                [ngClass]="{ 'mb-5': !last }">
                                <a
                                    [href]="['/case-studies/' + cs.slug]"
                                    [routerLink]="['/case-studies', cs.slug]">
                                    <img
                                        class="image-as-bg hover"
                                        [src]="
                                            cs.imageUrl
                                                ? cs.imageUrl
                                                : 'https://api.ysprod.co.uk/cms/images/assets/no-image.png'
                                        "
                                        [appScrset]="
                                            cs.imageUrl
                                                ? cs.imageUrl
                                                : 'https://api.ysprod.co.uk/cms/images/assets/no-image.png'
                                        "
                                        [width]="500" />
                                </a>
                                <div class="mt-4 mb-3">
                                    <a
                                        class="ff-spectral fs-6 fw-bold text-primary"
                                        [href]="['/case-studies/' + cs.slug]"
                                        [routerLink]="['/case-studies', cs.slug]">
                                        {{ cs.title }}
                                    </a>
                                </div>
                                <p class="text-primary op-8 mb-4">
                                    {{ cs.location }}
                                </p>
                                <a
                                    class="btn btn-wide btn-primary fw-bold"
                                    [href]="'/case-studies/' + cs.slug"
                                    [routerLink]="['/case-studies', cs.slug]">
                                    View project
                                </a>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </section>

            <ng-container *ngIf="priceEngine.jobLot">
                <section
                *ngIf="products.length"
                class="bg-slate-10">
                <div class="container py-4 py-xl-5">
                    <h2 class="fs-5 fw-bold text-center text-xl-start mb-4">Similar Batches Available:</h2>
                    <div class="product-tiles">
                        <div
                            class="product-tile"
                            (click)="openProductDetails(product.slug)"
                            *ngFor="let product of products">
                            <div class="title-image-holder">
                                <img
                                    *ngIf="product.productImages"
                                    class="title-image"
                                    src="{{ product?.productImages[0]?.url }}?width=310" />
                            </div>
                            <div class="title-bottom">
                                <div class="title-name">{{ product.name }}</div>
                                <div class="product-params">
                                    <div class="product-param sq-meters">
                                        <svg-icon
                                            src="assets/images/marketplace/icon-compass-tool.svg"
                                            [svgClass]="'product-param-icon'"></svg-icon>
                                        {{ product.stockFree }} {{product.sellUnitName}}
                                    </div>
                                    <div class="elipse">&nbsp;</div>
                                    <div class="product-param product-type">
                                        <svg-icon
                                            src="assets/images/marketplace/icon-kanban.svg"
                                            [svgClass]="'product-param-icon'"></svg-icon>
                                        {{ product.type }}
                                    </div>
                                    <div class="elipse">&nbsp;</div>
                                    <div class="product-param product-type">Code: {{ product.productCode }}</div>
                                </div>
                                <div class="product-price">{{ product.pricesFrom | currency: 'GBP' }} / sqm</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            </ng-container>

            <app-contact-cta></app-contact-cta>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!priceEngine.product && priceEngine.isLoaded">
    <app-page-not-found></app-page-not-found>
    <app-trustpilot-review-slider></app-trustpilot-review-slider>
    <app-contact-cta></app-contact-cta>
</ng-container>
